import { render, staticRenderFns } from "./Occupant.vue?vue&type=template&id=ac2a826a"
import script from "./Occupant.vue?vue&type=script&lang=js"
export * from "./Occupant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports